const ConsoleLogger = require('./ConsoleLogger');

const logFactory = (name, debugEnabled = true) => new ConsoleLogger(
    name,
    debugEnabled
);

module.exports = logFactory;
